document.addEventListener('DOMContentLoaded', function () {
    const urlConfigs = {
        'pulp_1-day'  : {
            title          : window.themeSettings?.cleanse_1day_seo_title || 'Our 1-Day Cleanses | One Day Juice Cleanse',
            metaDescription: window.themeSettings?.cleanse_1day_meta_description || 'Quick reset with our 1-day juice cleanse. Perfect for busy lifestyles and on-the-go wellness.',
            pageTitle      : window.themeSettings?.cleanse_1day_title || 'Our 1-Day Cleanses',
            pageDescription: window.themeSettings?.cleanse_1day_description || `Give your body a quick reset with a delicious one-day juice cleanse. Our busy lives can make it difficult to give your body the nutrition it needs. A one-day juice cleanse is perfect for on-the-go, and will give a refreshing reset for both your body and mind. Our juices are packed with essential nutrients, vitamins and antioxidants from fresh fruits and vegetables, designed to cleanse your body from the inside out.<br><br>Breakfree from unhealthy habits! Our one-day juice cleanses are a simple and effective way to nourish your body and feel revitalized.<br><br>🌿 100% organic<br>🍋 Made with 3-4 lbs of fresh produce per bottle<br>❄️ Cold pressed for maximum nutrition<br>⛔ No heat processing, preservatives, colors, or flavors`
        },
        'pulp_2-day'  : {
            title          : window.themeSettings?.cleanse_2day_seo_title || 'Our 2-Day Cleanses | Premium Juice Cleanse',
            metaDescription: window.themeSettings?.cleanse_2day_meta_description || 'Start your wellness journey with our 2-day juice cleanse. Perfect for beginners looking to reset and rejuvenate.',
            pageTitle      : window.themeSettings?.cleanse_2day_title || 'Our 2-Day Cleanses',
            pageDescription: window.themeSettings?.cleanse_2day_description || `Whether you're looking to kick-start a healthier lifestyle, or if you're looking to give your body a well-deserved reset, a 2 day juice cleanse is the perfect way to restore balance. Packed with vitamins and minerals, our cold-pressed juices will leave you feeling revitalized. In just 48 hours, this gentle cleanse helps flush out toxins, improve digestion, support immunity, and boost your energy levels – all while keeping you hydrated and satisfied with our nutrition-packed, cold-pressed juices.<br><br>Made with fresh, organic, high-quality ingredients, our cold-pressed juice is delicious and convenient. Start your 2 day juice cleanse today!<br><br>🌿 100% organic<br>🍋 Made with 3-4 lbs of fresh produce per bottle<br>❄️ Cold pressed for maximum nutrition<br>⛔ No heat processing, preservatives, colors, or flavors`
        },
        'pulp_3-7-day': {
            title          : window.themeSettings?.cleanse_3_7day_seo_title || 'Our 3-7 Day Cleanses | Extended Juice Cleanse Programs',
            metaDescription: window.themeSettings?.cleanse_3_7day_meta_description || 'Transform your health with our 3-7 day juice cleanse programs. Deep cleansing for serious wellness enthusiasts.',
            pageTitle      : window.themeSettings?.cleanse_3_7day_title || 'Our 3-7 Day Cleanses',
            pageDescription: window.themeSettings?.cleanse_3_7day_description || `A juice cleanse, the perfect way to reset, recharge and refresh your body. Available in 3 day, 5 day, or 7 day options, our nutrient-rich, cold-pressed juice blends are packed with vitamins, minerals and antioxidants to support your overall well-being. Each cleanse features a selection of fresh, organic, delicious juices to enhance immunity, hydration and overall wellness. In a week or less, our cold pressed juice will cleanse your body by improving digestion, eliminating toxins and reducing bloating and inflammation.<br><br>Whether you're looking to cleanse for a full week or over a long-weekend, choose a cleanse length that suits you and start feeling the difference.<br><br>🌿 100% organic<br>🍋 Made with 3-4 lbs of fresh produce per bottle<br>❄️ Cold pressed for maximum nutrition<br>⛔ No heat processing, preservatives, colors, or flavors`
        }
    };

    const originalTitle           = document.title;
    const originalMetaDescription = document.querySelector('meta[name="description"]')?.content || '';
    const originalPageTitle       = document.querySelector('.collection__info-heading')?.textContent || '';
    const originalPageDescription = document.querySelector('.collection-description')?.innerHTML || '';
    const originalOgTitle         = document.querySelector('meta[property="og:title"]')?.content || '';
    const originalOgDescription   = document.querySelector('meta[property="og:description"]')?.content || '';
    const originalOgUrl           = document.querySelector('meta[property="og:url"]')?.content || '';

    function getCurrentConfig() {
        const currentUrl = window.location.pathname;

        if (currentUrl.includes('pulp_1-day')) {
            return urlConfigs['pulp_1-day'];
        } else if (currentUrl.includes('pulp_2-day')) {
            return urlConfigs['pulp_2-day'];
        } else if (currentUrl.includes('pulp_3-7-day')) {
            return urlConfigs['pulp_3-7-day'];
        } else {
            return null;
        }
    }

    function updateDocumentTitle(title) {
        document.title = title;
    }

    function updateMetaDescription(description) {
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription      = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }
        metaDescription.content = description;
    }

    function updateOpenGraphTags(config) {
        let ogTitle = document.querySelector('meta[property="og:title"]');
        if (!ogTitle) {
            ogTitle = document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            document.head.appendChild(ogTitle);
        }
        ogTitle.content = config.title;

        let ogDescription = document.querySelector('meta[property="og:description"]');
        if (!ogDescription) {
            ogDescription = document.createElement('meta');
            ogDescription.setAttribute('property', 'og:description');
            document.head.appendChild(ogDescription);
        }
        ogDescription.content = config.metaDescription;

        let ogUrl = document.querySelector('meta[property="og:url"]');
        if (!ogUrl) {
            ogUrl = document.createElement('meta');
            ogUrl.setAttribute('property', 'og:url');
            document.head.appendChild(ogUrl);
        }
        ogUrl.content = window.location.href;
    }

    function restoreOpenGraphTags() {
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle && originalOgTitle) {
            ogTitle.content = originalOgTitle;
        }

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription && originalOgDescription) {
            ogDescription.content = originalOgDescription;
        }

        const ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl && originalOgUrl) {
            ogUrl.content = originalOgUrl;
        }
    }

    function updatePageHeading(title) {
        const heading = document.querySelector('.collection__info-heading');
        if (heading) {
            heading.textContent = title;
        }
    }

    function updatePageDescription(description) {
        const descriptionElement = document.querySelector('.collection-description');
        if (descriptionElement) {
            descriptionElement.innerHTML = description;
        } else {
            const headerInfo = document.querySelector('.collection__header-info');
            if (headerInfo) {
                const newDescription     = document.createElement('div');
                newDescription.className = 'collection__header-info__text';
                newDescription.innerHTML = description;
                headerInfo.appendChild(newDescription);
            }
        }
    }

    function addStructuredData(config) {
        const existingScript = document.querySelector('script[type="application/ld+json"]');
        if (existingScript) {
            existingScript.remove();
        }

        if (config) {
            const structuredData = {
                '@context'   : 'https://schema.org',
                '@type'      : 'CollectionPage',
                'name'       : config.pageTitle,
                'description': config.metaDescription,
                'url'        : window.location.href
            };

            const script       = document.createElement('script');
            script.type        = 'application/ld+json';
            script.textContent = JSON.stringify(structuredData);
            document.head.appendChild(script);
        }
    }

    function applyDynamicContent() {
        const config = getCurrentConfig();

        if (config) {
            updateDocumentTitle(config.title);
            updateMetaDescription(config.metaDescription);
            updateOpenGraphTags(config);
            updatePageHeading(config.pageTitle);
            updatePageDescription(config.pageDescription);
            addStructuredData(config);
        } else {
            updateDocumentTitle(originalTitle);
            updateMetaDescription(originalMetaDescription);
            restoreOpenGraphTags();
            updatePageHeading(originalPageTitle);
            updatePageDescription(originalPageDescription);
            addStructuredData(null);
        }
    }

    applyDynamicContent();
    window.addEventListener('popstate', function () {
        applyDynamicContent();
    });
});
